import {IndividualWithResult} from '../digital-id-service.domain';

// Value emitted by the <individual-details-list> pre-submission review step. `individuals` are the
// latest SAVED rows (source of truth: ApplicationIndividual via /digitalId/getApplicationIndividuals),
// not in-progress form edits - the component persists edits itself (autosave + flush on navigation).
export type IndividualDetailsListValue = {
  individuals: IndividualWithResult[],
  /** The individual's guid, not the numeric row id: the API shape's id would not round-trip. */
  primaryContactId: string | null,
} | null;
